import React from 'react';
import { string, node } from 'prop-types';
import cx from 'classnames';

import s from './index.module.css';

const StatusTag = ({ className, background = 'blue', children }) => (
  <div
    className={cx(s.tag, className, {
      [s.backgroundGreen]: background === 'green',
      [s.backgroundBlue]: background === 'blue',
      [s.backgroundGrey]: background === 'grey',
    })}
  >
    {children}
  </div>
);

StatusTag.propTypes = {
    className: string,
    children: node,
    background: string,
};

export default StatusTag;
